import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no flight to Seattle needed",
      "Ideal for ANC international flyers & Ted Stevens passengers",
      "Perfect for oil & gas workers on rotational overseas assignments",
      "Great for UAA & APU study-abroad students",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Anchorage post offices",
      "Good for planned international trips from ANC",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only, Alaska mail delays add 1–2 extra weeks",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Anchorage facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Seattle — flight required, no road access from Alaska",
      "NPIC appointment required — no drive option exists from Anchorage",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Airfare + hotel costs on top of passport fees",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Anchorage"
      headingExtra="AK"
      introText="Anchorage and Alaska travelers — Ted Stevens ANC international flyers, oil & gas workers on rotational overseas assignments, UAA and APU study-abroad students, cruise and seasonal hospitality workers, international commercial fishing crews, JBER military families on PCS orders, and Bush Alaska residents connecting through Anchorage — have several options for getting a passport fast. Here is how they compare, and why most Alaskans choose a U.S. Department of State registered passport courier rather than booking an expensive last-minute flight to the Seattle Passport Agency."
      options={options}
      emergencyDescription="Alaska has zero regional passport agencies. The closest agency is in Seattle, Washington — accessible only by air (roughly 3.5-hour flight from Anchorage). You must obtain an NPIC appointment before traveling, factor in round-trip airfare and hotel costs, and walk-ins are not accepted at the Seattle Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Alaska has no regional passport agency — the closest is Seattle, Washington, accessible only by commercial flight. Not all applicants qualify for Regional Agency Processing."
    />
  );
}